import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const DraftIssuesContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    flex: 1;
    min-height: 0;
`;

export const IssueCardList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const EmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 2.4rem;
    color: ${tokens.text.secondary};
    font-size: 1.4rem;
    text-align: center;
`;
